import { AppDispatch, AppThunkAction } from '..';
import { DisplayTypeState } from './state';
import { DISPLAY_TYPE_CHANGE, DisplayTypeChange } from './types';

const displayTypeChangeAction = (displayType: DisplayTypeState): DisplayTypeChange => {
    return {
        type: DISPLAY_TYPE_CHANGE,
        payload: displayType
    };
};

export function changeDisplayType(displayType: DisplayTypeState): AppThunkAction {
    return (dispatch: AppDispatch) => {
        dispatch(displayTypeChangeAction(displayType));
    };
}
